import { render, staticRenderFns } from "./trip_details.vue?vue&type=template&id=012943fe&scoped=true&"
import script from "./trip_details.vue?vue&type=script&lang=js&"
export * from "./trip_details.vue?vue&type=script&lang=js&"
import style0 from "./trip_details.vue?vue&type=style&index=0&id=012943fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012943fe",
  null
  
)

export default component.exports